
export default {
  name: 'GradientBackground',
  computed: {
    isDark() {
      return this.$store.state.theme === 'dark';
    }
  }
}
